<template>
  <div class="factura margin-auto">
    <div v-if="factura.empresa">
      <div class="text-center">
        <table class="margin-auto">
          <tbody>
            <tr>
              <td class="text-bold" style="white-space: pre-line">
                <br />
                {{ factura.consecutivo.header }}
              </td>
            </tr>
            <tr>
              <td class="text-left" style="white-space: pre-line">
                <div v-if="factura.consecutivo.is_factura">
                  <div>
                    ======================================================
                  </div>
                  <div class="text-left">
                    Resolución de Autorización No.{{
                      factura.consecutivo.resolucion
                    }}
                    <br />
                    Prefijo [{{ factura.consecutivo.prefijo }}] Numeración de
                    {{ factura.consecutivo.consecutivo_inicial }} a
                    {{ factura.consecutivo.consecutivo_final }}
                    <br />
                    Fecha vencimiento {{ factura.consecutivo.fecha_inicial }} a
                    {{ factura.consecutivo.fecha_final }}
                    <br />
                    Vigencia {{ factura.consecutivo.tiempo }}
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <td class="text-left">
                <div>
                  ------------------------------------------------------
                </div>
                <div>
                  <div v-if="factura.consecutivo.is_factura">
                    FACTURA DE VENTA POS:
                    <span style="color: red">{{
                      factura.consecutivo.prefijo
                    }}</span
                    >-<span style="color: red">{{
                      factura.consecutivo.numero
                    }}</span>
                  </div>
                  <div v-else>
                    RECIBO:
                    <span style="color: red">{{
                      factura.consecutivo.prefijo
                    }}</span
                    >-<span style="color: red">{{
                      factura.consecutivo.numero
                    }}</span>
                  </div>
                </div>
                <div>
                  ------------------------------------------------------
                </div>
              </td>
            </tr>
            <tr>
              <td class="text-left">
                <div>FECHA: {{ factura.date }} {{ factura.time }}</div>
                <div v-if="factura.isFinalCustomer && GLOBAL.COUNTRY == 'CO'">
                  <div>CLIENTE: CONSUMIDOR FINAL</div>
                  <div>NIT/CC: 222222222222</div>
                </div>
                <div v-if="factura.isFinalCustomer && GLOBAL.COUNTRY == 'MX'">
                  <div>CLIENTE: PUBLICO GENERAL</div>
                  <div>RFC: XAXX010101000</div>
                </div>
                <div
                  v-if="!factura.isFinalCustomer && factura.customer != null"
                >
                  <div>
                    CLIENTE: <br /><b>{{ factura.customer.name }}</b>
                  </div>
                  <div v-if="GLOBAL.COUNTRY == 'CO'">
                    <div>
                      NIT/CEDULA: {{ factura.customer.identification_number }}
                    </div>
                  </div>
                  <div v-else>
                    <div>RFC: {{ factura.customer.identification_number }}</div>
                  </div>
                </div>
              </td>
            </tr>
            <tr>
              <td class="text-left" v-if="factura.origen.placa_vin != null">
                <div v-if="factura.origen.placa_vin">
                  PLACA: {{ factura.origen.placa_vin }}
                </div>
                <div v-if="factura.origen.kilometraje">
                  KILOMETRAJE: {{ factura.origen.kilometraje }}
                </div>
              </td>
            </tr>
            <tr>
              <td class="text-left">
                <div>
                  ------------------------------------------------------
                </div>
                <div>
                  <table width="100%">
                    <tbody>
                      <tr>
                        <td width="25%">CARA:</td>
                        <td width="25%">{{ factura.origen.posicion }}</td>
                        <td width="25%">MANGUERA:</td>
                        <td width="25%">{{ factura.origen.manguera }}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div>
                  ------------------------------------------------------
                </div>
              </td>
            </tr>
            <tr>
              <td class="text-left">
                <div>
                  <table width="100%">
                    <tbody>
                      <tr>
                        <td class="text-left text-bold" width="10%">Cod</td>
                        <td class="text-left text-bold" width="10%">Cant</td>
                        <td class="text-left text-bold">Producto</td>
                        <td class="text-right text-bold" width="20%">V.Unit</td>
                        <td class="text-right text-bold" width="25%">Total</td>
                      </tr>
                      <tr v-for="item in factura.items" :key="item._id">
                        <td class="text-center">{{ item.code }}</td>
                        <td class="text-center">{{ item.base_quantity }}</td>
                        <td class="text-left">{{ item.description }}</td>
                        <td class="text-right">
                          {{ GLOBAL.FORMATO_MONEY(item.price_amount) }}
                        </td>
                        <td class="text-right">
                          {{
                            GLOBAL.FORMATO_MONEY_BASIC(
                              item.price_amount * item.base_quantity
                            )
                          }}
                          {{ item.letter }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div>
                  ------------------------------------------------------
                </div>
              </td>
            </tr>
            <tr>
              <td class="text-left">
                <div>
                  <table width="100%">
                    <tbody>
                      <tr>
                        <td>Sub Total >>>></td>
                        <td>$</td>
                        <td width="40%" class="text-right">
                          {{
                            GLOBAL.FORMATO_MONEY_BASIC(
                              factura.invoiceTaxExclusiveTotal.toFixed(0)
                            )
                          }}
                        </td>
                      </tr>
                      <tr>
                        <td>Descuento >>>></td>
                        <td>$</td>
                        <td class="text-right">0</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div>
                  ------------------------------------------------------
                </div>
                <div>
                  <table width="100%">
                    <tbody>
                      <tr>
                        <td>TOTAL >>>></td>
                        <td>$</td>
                        <td width="40%" class="text-right">
                          {{
                            GLOBAL.FORMATO_MONEY_BASIC(
                              factura.invoiceTaxExclusiveTotal.toFixed(0)
                            )
                          }}
                        </td>
                      </tr>
                      <tr>
                        <td>TOTAL Impuesto >>>></td>
                        <td>$</td>
                        <td class="text-right">
                          {{
                            GLOBAL.FORMATO_MONEY_BASIC(
                              (
                                factura.totalToPay -
                                factura.invoiceTaxExclusiveTotal
                              ).toFixed(0)
                            )
                          }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
                <div>
                  ------------------------------------------------------
                </div>
              </td>
            </tr>
            <tr>
              <td class="text-left">
                <div>
                  <table width="100%">
                    <tbody>
                      <tr>
                        <td width="35%" class="text-left">Impuesto</td>
                        <td width="5%" class="text-center">%</td>
                        <td width="30%" class="text-right">Base</td>
                        <td width="35%" class="text-right">Valor Imp.</td>
                      </tr>
                      <tr
                        v-for="item in factura.allTaxTotals"
                        :key="item.tax_id"
                      >
                        <td class="text-left">
                          {{ item.tax_type }} {{ item.tax_description }}
                        </td>
                        <td class="text-center">{{ item.percent }}</td>
                        <td class="text-right">
                          {{ GLOBAL.FORMATO_MONEY_BASIC(item.taxable_amount) }}
                        </td>
                        <td class="text-right">
                          {{ GLOBAL.FORMATO_MONEY_BASIC(item.tax_amount) }}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </td>
            </tr>
            <tr>
              <td>
                <div>
                  ------------------------------------------------------
                </div>
                <table width="100%">
                  <tbody>
                    <tr>
                      <td class="text-left">
                        <div v-if="factura.payment">
                          {{ factura.payment.payment_name }}
                        </div>
                      </td>
                      <td class="text-right">
                        {{ GLOBAL.FORMATO_MONEY_BASIC(factura.totalToPay) }}
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div>
                  ------------------------------------------------------
                </div>
                <table width="100%">
                  <tbody>
                    <tr>
                      <td class="text-left">Promotor</td>
                      <td class="text-left">{{ factura.promotor.nombre }}</td>
                    </tr>
                  </tbody>
                </table>

                <div>================================================</div>
                <div v-if="factura.consecutivo.is_factura">
                  <div v-if="factura.hash">
                    <div>
                      Para obtener su factura electrónica ingrese<br />
                      en GestionElectronica.co y registre el<br />
                    </div>
                    <div>
                      código hash:
                      <span style="color: red"
                        ><b>{{ factura.hash }}</b></span
                      >
                    </div>
                    <div style="white-space: pre-line">
                      {{ factura.consecutivo.footer }}
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import GLOBAL from "../Global.js";

export default {
  props: {
    object: Object,
    showData: Boolean,
  },
  data() {
    return {
      GLOBAL,
      show: false,
      factura: [],
    };
  },
  created() {
    this.factura = [];
    this.factura.empresa = [];
    this.factura.empresa.razon_social = "";
    this.factura.consecutivo = [];
    this.factura.origen = [];
    this.factura.promotor = [];
    this.factura.invoiceTaxExclusiveTotal = 0;
    this.factura.payment = [];
    this.factura.payment.payment_name = "";
  },
  mounted() {
    //if (typeof this.object.razon_social != 'undefined') {
    this.factura = this.object;
    //}
  },
};
</script>

<style scoped></style>
